<template>

</template>

<script>
    export default {
        name: "sso.vue",
        data() {
            return {
                appId: '',
                roleId: ''
            }
        },
        created() {
            this.appId = this.$route.query.appId;
            this.roleId = this.$route.query.roleId;
            sessionStorage.setItem('appId', this.appId);
            sessionStorage.setItem('roleId', this.roleId);
            this.sso()
        },
        methods: {
            sso() {
                this.$api.post('/user/sso', {
                    roleId: this.roleId
                }).then(resp => {
                    if (resp) {
                        this.$router.push('/')
                    } else {
                        this.$router.push("/ssoLogin");
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>
